<template lang="pug">

.tabs-content__item(:class="[{'is-active' : active }, _class + '-content__item']" )
  slot

</template>

<script>
export default {
  props: {
    name: { required: true },
    selected: { default: false },
    subtitle: {default: false}
  },

  data () {
    return {
      active: false,
      height: null
    }
  },

  computed: {
    _class () {
      return this.$parent.type
    }
  },

  mounted () {
    this.active = this.selected
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tab.vue